import { Dict } from '@/models/common'
import { service } from 'eco-cli'
const { system } = service

export const getDict = (dictId) => system.withToken.get('/system/dict/select/dictItem/' + dictId).then(data => {
  return data?.map(item => {
    return Dict.create(item.code, item.name)
  })
})